export enum Variant {
  NotDefined = 0,
  Ok = 1,
  FullCapacity = 2,
  Critical = 3,
}

export interface MainCardProps {
  variant?: Variant;
  clickable?: boolean;
}

export interface CardTagProps {
  variant?: Variant;
}

export interface DailyDeliveryResponse {
  DeliveryDate: string;
  FamilyId: number;
  Family: string;
  BreweryId: number;
  Brewery: string;
  OrdersCount: number;
  TotalVolume: number;
  TotalExpected: number;
  Capacity: number;
  Status: number;
}

export interface BreweryTableData {
  columns: string[];
  rows: BreweryTableRow[];
}

export interface BreweryTableRow {
  Brewery: string;
  BreweryId: number;
  [date: string]: DailyDeliveryCellData | string | number;
}

export interface DailyDeliveryCellData {
  TotalVolume: number;
  OrdersCount: number;
  TotalExpected: number;
  Capacity: number;
  Status: Variant;
  Family: string;
  FamilyId: number;
}

export interface FilterState {
  _minDeliveryDate?: string;
  _maxDeliveryDate?: string;
  FamilyIds?: string;
  BreweryIds?: number[];
  Status?: number[];
}
